import Head from "next/head";
import { memo } from "react";
import styled from "styled-components";
import Breadcrumbs from "../components/breadcrumbs/Breadcrumbs";
import DashboardProjectCatalystBanner from "../components/dashboard/DashboardProjectCatalystBanner";
import { CommunitySocialCards } from "../components/card/CommunitySocialCards";
import Heading from "../components/heading/Heading";
import { PageContainer } from "../components/page-partials/PageContainer";
import Text from "../components/text/Text";
import { pxToRem } from "@input-output-hk/px-to-rem";
import colors from "../tokens/colors";
import {
  forTabletPortraitDown,
  forTabletPortraitUp
} from "../tokens/media-queries";
import { GetServerSideProps } from "next";
import { setCacheHeader } from "../page-cache";
import createServerContext from "../context/server-context";

// TODO
const PageHead = memo(() => (
  <Head>
    <title>Community Channels | Essential Cardano</title>
    <meta name="description" content="Talk to our community" />
    <link rel="icon" href="/favicon.ico" />
    <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
    <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
    <link
      rel="canonical"
      href={"https://www.essentialcardano.io/community"}
      key="canonical"
    />
  </Head>
));
PageHead.displayName = "PageHead";

// set a max-width here so that the subtitle's text breaks nicely onto multiple lines
const TitleContainer = styled.div`
  max-width: ${pxToRem(520)};
  margin-bottom: var(--spacing-large);

  @media ${forTabletPortraitUp} {
    margin-bottom: var(--spacing-xlarge);
  }
`;

const PageTitle = styled(Heading)`
  font-size: ${pxToRem(44)};
  line-height: ${pxToRem(50)};
  margin: 0 0 0.75rem 0;
  @media ${forTabletPortraitDown} {
    font-size: ${pxToRem(35)};
    margin-top: ${pxToRem(24)};
  }
`;

const PageSubtitle = styled(Text)`
  color: ${colors.primary.slateGrey};
  flex: 0 1 0;
`;

const CommunityPage: React.FC = () => {
  return (
    <>
      <Breadcrumbs />
      <PageHead />
      <PageContainer>
        <TitleContainer>
          <PageTitle level="1">Join our community</PageTitle>
          <PageSubtitle>
            Follow us and our partners on social media for all the latest news
            and updates from the Cardano ecosystem
          </PageSubtitle>
        </TitleContainer>
        <CommunitySocialCards />
        <DashboardProjectCatalystBanner />
      </PageContainer>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (baseCtx) => {
  setCacheHeader(createServerContext(baseCtx), baseCtx.res);

  return { props: {} };
};

export default CommunityPage;
